module.exports = __webpack_public_path__ + "img/SAR-alt.57cab1d6.svg";